module.exports = (original)-> ({React,FormGroup,ImageUpload,Typeahead,ImageInsert})=>
  (props)=> 
    return <div></div> if(!props.user) 
    #make it possible to return global override of component
    {id,username,password,first_name,surname,email,address,city,state,postcode,country,phone1,phone2,org_id,site,jobtitle,tags} = props.user
    # stop autofill of username and password
    [
      <input type="text" key={"username-catch"} name="username" style={{position:"absolute", left:"-10000px"}} />
      <input type="password" key={"password-catch"} name="password" style={{position:"absolute", left:"-10000px"}} />

      <FormGroup label="User Image" key="image">
        <ImageInsert width={100} src={"/images/avatars/user"+id+".jpg"} onFileDropped={(file)=> props.fileDropped(file)} />
      </FormGroup>

      <FormGroup label="Organisation" key="name">
        <Typeahead value={org_id} options={props.orgs} max={5} label="name" onChange={(new_org)=> props.onUpdate(id,"org_id",new_org.id)} />
      </FormGroup>

      <FormGroup label="Username" key="username">
        <input type="text" className="form-control" placeholder="Username" value={username ?= ""} onChange={(e)=> props.onUpdate(id,"username",e.target.value)} />
      </FormGroup>

      <FormGroup label="Password" key="password">
        <input type="password" className="form-control" placeholder="Password" value={password ?= ""} onChange={(e)=> props.onUpdate(id,"password",e.target.value)} />
      </FormGroup>

      <FormGroup label="First Name" key="first_name">
        <input type="text" className="form-control" id="first_name" placeholder="First Name" value={first_name ?= ""} onChange={(e)=> props.onUpdate(id,"first_name",e.target.value)} />
      </FormGroup>

      <FormGroup label="Surname" key="surname">
        <input type="text" className="form-control" id="surname" placeholder="Surname" value={surname ?= ""} onChange={(e)=> props.onUpdate(id,"surname",e.target.value)} />
      </FormGroup>

      <FormGroup label="Email" key="email">
        <input type="email" className="form-control" id="email" placeholder="Email" value={email ?= ""} onChange={(e)=> props.onUpdate(id,"email",e.target.value)} />
      </FormGroup>
      
      <FormGroup label="Address" key="address">
        <textarea rows={5} className="form-control" id="address" placeholder="Address" value={address ?= ""} onChange={(e)=> props.onUpdate(id,"address",e.target.value)} />
      </FormGroup>

      <FormGroup label="City" key="City">
        <input type="text" className="form-control" id="city" placeholder="City" value={city ?= ""} onChange={(e)=> props.onUpdate(id,"city",e.target.value)} />
      </FormGroup>

      <FormGroup label="State" key="State">
        <select className="form-control" value={state ?= ""} onChange={(e)=> props.onUpdate(id,"state",e.target.value)} id="state" placeholder="state" disabled={country!="US"} >
          <option key="nostate" value="">{if country=="US" then "Please Select" else ""}</option>
            {props.postageStates?.map (state,idx)-> <option value={state.code} key={idx}>{state.name}</option>}
        </select>
      </FormGroup>

      <FormGroup label="Postcode" key="postcode">
        <input type="text" className="form-control" id="postcode" placeholder="Postcode" value={postcode ?= ""} onChange={(e)=> props.onUpdate(id,"postcode",e.target.value)} />
      </FormGroup>

      <FormGroup label="Country" key="country">
        <select className="form-control" value={country ?= ""} onChange={(e)=> props.onUpdate(id,"country",e.target.value)} id="country" placeholder="Country">
          <option key="nocountry" value="">Please Select</option>
            {props.countries.map (country,idx)-> <option value={country.code} key={idx}>{country.name}</option>}
        </select>
      </FormGroup>

      <FormGroup label="Telephone" key="telephone">
        <input type="text" className="form-control" id="telephone" placeholder="Telephone" value={phone1 ?= ""} onChange={(e)=> props.onUpdate(id,"phone1",e.target.value)} />
      </FormGroup>

      <FormGroup label="Mobile" key="mobile">
        <input type="text" className="form-control" id="mobile" placeholder="Mobile" value={phone2 ?= ""} onChange={(e)=> props.onUpdate(id,"phone2",e.target.value)} />
      </FormGroup>

      <FormGroup label="Site">
        <input type="text" className="form-control" id="site" placeholder="Site" value={site || ""} onChange={(e)=> props.onUpdate(id,"site",e.target.value)} />
      </FormGroup>

      <FormGroup label="Job Title">
        <input type="text" className="form-control" id="jobtitle" placeholder="Job Title" value={jobtitle || ""} onChange={(e)=> props.onUpdate(id,"jobtitle",e.target.value)} />
      </FormGroup>

      <FormGroup label="Tags">
        <textarea rows={3} className="form-control" id="tags" placeholder="Tags" value={tags || ""} onChange={(e)=> props.onUpdate(id,"tags",e.target.value)} />
      </FormGroup>

      <FormGroup label="Public" checkbox={true}>
        <input type="checkbox" id="public" checked={props.user.public || false} onChange={(e)=> props.onUpdate(id,"public",e.target.checked)} />
      </FormGroup>

    ]


